/***
 *
 *   SIGN UP (invitee user)
 *   Phase 9 — auth chrome. Keep invite query params + live API.
 *
 **********/

import React, { useContext } from 'react';
import { Animate, Form, Link } from 'components/lib';
import { AuthPage } from 'components/auth/authPage';
import { AuthContext } from 'app/auth';
import { useTranslate } from 'app/translations';

export function SignupUser(props) {
    const { _t } = useTranslate();
    const context = useContext(AuthContext);
    const url = window.location.href;
    const params = new URLSearchParams(url.split('?')[1]);

    const id = params.get('id');
    const email = params.get('email');
    const project = params.get('project');

    return (
        <Animate type="pop">
            <AuthPage
                title={_t('user.create.title')}
                description={_t('signup.description')}
                footer={
                    <>
                        {_t('signup.already')} <Link url="/signin" text={_t('signin.label')} />
                    </>
                }>
                <Form
                    data={{
                        first_name: {
                            label: _t('firstName.title'),
                            value: '',
                            type: 'text',
                            required: true,
                            errorMessage: _t('firstName.empty'),
                        },
                        last_name: {
                            label: _t('lastName.title'),
                            value: '',
                            type: 'text',
                            required: true,
                            errorMessage: _t('lastName.empty'),
                        },
                        email: {
                            label: _t('email.label'),
                            value: email,
                            type: 'email',
                            required: true,
                        },
                        password: {
                            label: _t('password.label'),
                            type: 'password',
                            required: true,
                            complexPassword: true,
                        },
                        confirm_password: {
                            type: 'hidden',
                            value: null,
                        },
                        invite_id: {
                            type: 'hidden',
                            value: id,
                        },
                    }}
                    auth={false}
                    url="/api/user"
                    method="POST"
                    buttonText={_t('user.create.label')}
                    callback={context.signin}
                    injectedData={{ project_id: project }}
                />
            </AuthPage>
        </Animate>
    );
}
